import React from "react";
import PropTypes from "prop-types";

import "./TabMenu.scss";

const TabMenu = ({ tabs, activeTab, onClickTab, hiddenMobile, user }) => (
	<header>
		<nav className={`tab-menu sub-nav hidden-print ${hiddenMobile ? "hidden-xs" : ""}`}>
			<ul className="nav text-center">
				{tabs.map(tab => {
					if (
						(tab.type !== "drafts" ||
							(tab.type === "drafts" && !user.isSuperAdmin())) &&
						(tab.type !== "requests" ||
							(tab.type === "requests" &&
								user.Features.includes("ClientJobRequests"))) &&
						(tab.type !== "audit" || (tab.type === "audit" && user.isSuperAdmin()))
					) {
						return (
							<li
								key={`projects_tab_${tab.type}`}
								className={tab.tabNumber === activeTab ? "active" : ""}
								data-test-id={tab.dataTestId ?? ""}
							>
								<button
									type="button"
									className="btn btn-link tabmenu-btn"
									onClick={() => onClickTab(tab)}
								>
									{tab.text}
								</button>
							</li>
						);
					}
					return null;
				})}
			</ul>
		</nav>
	</header>
);

TabMenu.propTypes = {
	tabs: PropTypes.arrayOf(PropTypes.object),
	activeTab: PropTypes.number,
	onClickTab: PropTypes.func,
	hiddenMobile: PropTypes.bool,
	user: PropTypes.object,
};

TabMenu.defaultProps = {
	tabs: [],
	activeTab: 0,
	onClickTab: () => {},
	hiddenMobile: false,
	user: {},
};

export default TabMenu;
